import { Routes } from '@angular/router';
import { DashboardShellComponent } from './shared/shell/dashboard-shell.component';
import { authGuard } from './shared/guards/auth.guard';
import { adminGuard } from './shared/guards/admin.guard';
import { mappingsGuard } from './shared/guards/mappings.guard';
import { participantsGuard } from './shared/guards/participants.guard';
import { reportingGuard } from './shared/guards/reporting.guard';
import { pendingChangesGuard } from './shared/guards/pending-changes.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard/rf-wizard', pathMatch: 'full' },
  {
    path: 'login-failed',
    loadComponent: () =>
      import('./pages/login-failed/login-failed.component').then(
        (m) => m.LoginFailedComponent
      ),
  },
  {
    path: 'not-authorized',
    loadComponent: () =>
      import('./pages/not-authorized/not-authorized.component').then(
        (m) => m.NotAuthorizedComponent
      ),
  },
  {
    path: 'waking-up',
    loadComponent: () =>
      import('./pages/waking-up/waking-up.component').then(
        (m) => m.WakingUpComponent
      ),
  },
  {
    path: 'dashboard',
    component: DashboardShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'rf-wizard',
        title: 'Wizard – Carry Bridge',
        loadComponent: () =>
          import('./domains/rf-upload-wizard/views/rf-upload-wizard.component').then(
            (m) => m.RfUploadWizardComponent
          ),
      },
      {
        path: 'mappings',
        title: 'Mappings – Carry Bridge',
        canActivate: [mappingsGuard],
        loadComponent: () =>
          import('./domains/mappings/views/mappings.component').then(
            (m) => m.MappingsComponent
          ),
      },
      {
        path: 'participants',
        title: 'Participants – Carry Bridge',
        canActivate: [participantsGuard],
        loadComponent: () =>
          import('./domains/participants/views/participants.component').then(
            (m) => m.ParticipantsComponent
          ),
      },
      {
        path: 'submissions',
        title: 'Submissions – Carry Bridge',
        loadComponent: () =>
          import('./domains/submission-review/views/submission-browse.component').then(
            (m) => m.SubmissionBrowseComponent
          ),
      },
      {
        path: 'submissions/:id',
        title: 'Submission – Carry Bridge',
        loadComponent: () =>
          import('./domains/rf-upload-wizard/views/rf-upload-wizard.component').then(
            (m) => m.RfUploadWizardComponent
          ),
      },
      {
        path: 'reporting',
        title: 'Reporting – Carry Bridge',
        canActivate: [reportingGuard],
        loadComponent: () =>
          import('./domains/reporting/views/reporting.component').then(
            (m) => m.ReportingComponent
          ),
      },
    ],
  },
  {
    path: 'admin',
    canActivate: [authGuard, adminGuard],
    loadComponent: () =>
      import('./domains/admin/views/admin-shell.component').then(
        (m) => m.AdminShellComponent
      ),
    children: [
      {
        path: 'users',
        title: 'Users – Carry Bridge',
        loadComponent: () =>
          import('./domains/admin/views/user-management.component').then(
            (m) => m.UserManagementComponent
          ),
      },
      {
        path: 'permissions/submissions',
        title: 'Submission Permissions – Carry Bridge',
        canDeactivate: [pendingChangesGuard],
        loadComponent: () =>
          import('./domains/admin/views/permissions.component').then(
            (m) => m.PermissionsComponent
          ),
      },
      {
        path: 'permissions/mappings',
        title: 'Mapping Permissions – Carry Bridge',
        canDeactivate: [pendingChangesGuard],
        loadComponent: () =>
          import('./domains/admin/views/permissions.component').then(
            (m) => m.PermissionsComponent
          ),
      },
      { path: '', redirectTo: 'users', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '/dashboard/rf-wizard' },
];
